module.exports = __webpack_public_path__ + "static/media/CodeofConduct.f7c29239.png";